import React from "react";
import styled from "styled-components/macro";
//import myTuluCover from "../../images/MyTulu/riderentImg.webp";
import myTuluCover from "../../images/MyTulu/RRPS-new.png";
import { device } from "../device";

const RideRentPrintShop = () => {
  return (
    <Wrapper>
      <SectionImg src={myTuluCover} alt={"myTuluCover"} />

      <SectionWrapper>
        <Section>
          <Title>Rent</Title>
          <Text>
            {
              "Provide your residents with everything from vacuum cleaners to home theater projectors"
            }
          </Text>
        </Section>

        <Section>
          <Title>Ride</Title>
          <Text>
            {"Your own in-building micro-mobility solution for residents"}
          </Text>
        </Section>

        <Section>
          <Title>Shop</Title>
          <Text>
            {
              "Offer a range of products that residents can purchase on the spot"
            }
          </Text>
        </Section>

        <Section>
          <Title>Print</Title>
          <Text>
            {
              "Residents can now do all their business without needing an office"
            }
          </Text>
        </Section>
      </SectionWrapper>
    </Wrapper>
  );
};

export { RideRentPrintShop };

const Wrapper = styled.div`
  display: flex;
  position: relative;
  font-family: "Lexend", serif;
  @media ${device.mobileS} {
    flex-direction: column;
    padding: 35px 29px;
  }
  @media ${device.tablet} {
    flex-direction: row;
    padding: 100px 80px;
  }
`;

const SectionImg = styled.img`
  object-fit: cover;
  @media ${device.mobileS} {
    width: 100%;
    flex-grow: 2;
  }
  @media ${device.tablet} {
    width: 60%;
  }
  @media ${device.laptopL} {
    width: 50%;
  }
`;

const SectionWrapper = styled.div`
  display: flex;
  position: relative;
  width: 100%;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  @media ${device.mobileS} {
    gap: 20px;
    align-items: flex-start;
    width: 100%;
    padding-top: 41px;
  }
  @media ${device.mobileM} {
    gap: 25px;
  }
  @media ${device.tablet} {
    padding: 0;
    width: 40%;
    margin-left: 50px;
    justify-content: space-between;
    align-items: stretch;
    gap: 15px;
  }
  @media ${device.laptopM} {
    gap: 35px;
  }
  @media ${device.laptopL} {
    margin-left: 100px;
  }
`;

const Section = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  @media ${device.mobileS} {
    border-top: 1px solid black;
    //width: calc(100% - 35px);
    width: 46%;
    //padding: 10px 0 30px 0;
    padding-top: 10px;
  }
  @media ${device.tablet} {
    border-top: 2px solid black;
    padding-top: 20px;
    /* height: 50%; */
    width: 45%;
  }
`;

const Title = styled.div`
  z-index: 1;
  font-weight: bold;
  margin-bottom: 4px;
  white-space: pre;
  text-transform: uppercase;
  @media ${device.mobileS} {
    font-size: 24px;
  }
  @media ${device.tablet} {
    font-size: 48px;
  }
`;

const Text = styled.p`
  z-index: 1;
  margin-bottom: 0;
  display: flex;
  white-space: pre-wrap;
  font-family: "DMSans", serif;
  @media ${device.mobileS} {
    font-size: 14px;
  }
  @media ${device.tablet} {
    font-size: 20px;
  }
`;
